import {oneOf} from 'shared/store';
import { observable, override, makeObservable } from 'mobx';
import QUESTION_TYPES from './questionTypes';
import QAQuestion from '../questions/QAQuestion';

class InterviewGuideQuestion extends QAQuestion {
  id;
  name;
  _relations = {
    questionType: oneOf(QUESTION_TYPES)
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      updateText: override,
      questionName: override
    });

    this.merge(other);
  }

  updateText(value) {
    this.merge({name: value});
  }

  get questionName() {
    return this.name;
  }
}

export default InterviewGuideQuestion;
